module.exports = __webpack_public_path__ + "static/img/05.ff77900.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/05.jpg
// module id = UGMk
// module chunks = 0